import type { FormData } from "../IntakeTypes";

export const DEFAULT_FORM_VALUES: Partial<FormData> = {
  estimated_settlement_amount: "",
  estimated_medical_settlement_value: "",
  reserve_settlement_amount: "",
  tentative_settlement_minimum: "",
  tentative_settlement_maximum: "",
  preferred_structure_settlement_broker: "",
  referring_party_name: "",
  additional_ack_email_recipients: [],
  grs_or_legacy_rcg: "",
  segmentation_type: "",
  rcg_carrier: "",
  referral_type: "",
  wcrc_case_id: "",
  claim_notes: "",
};
